/* DDC attribution: guarda en el carrito (atributos ocultos "_") los identificadores
   de Google Analytics, Google Ads y Meta para poder confirmar ventas desde el pedido,
   aunque el cliente no vuelva a la página de "Gracias" tras pagar en Wompi. */
(function () {
  'use strict';
  var LS = 'ddc_attr_v1', MAXAGE = 90 * 864e5;
  function ck(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function load() { try { var o = JSON.parse(localStorage.getItem(LS) || '{}'); return (o.t && Date.now() - o.t < MAXAGE) ? o : {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(LS, JSON.stringify(o)); } catch (e) {} }

  // 1) Captura de parámetros de la URL de entrada
  var st = load(), p = new URLSearchParams(location.search), got = false;
  ['gclid', 'gbraid', 'wbraid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
    var v = p.get(k); if (v) { st[k] = v.slice(0, 250); got = true; }
  });
  if (got || !st.landing) { st.landing = (location.pathname + location.search).slice(0, 250); st.ref = (document.referrer || '').slice(0, 200); st.t = Date.now(); }
  if (got) st.t = Date.now();
  save(st);

  function gaCid() { var v = ck('_ga'); var m = v.match(/^GA\d\.\d\.(\d+\.\d+)$/); return m ? m[1] : ''; }
  function gaSid() {
    var v = ck('_ga_FX3QDQ8CPZ'); if (!v) return '';
    var m = v.match(/^GS1\.\d\.(\d+)\./) || v.match(/^GS2\.\d\.s(\d+)/); return m ? m[1] : '';
  }
  function attrs() {
    var s = load(), utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
      .map(function (k) { return s[k] ? k.slice(4) + '=' + s[k] : ''; }).filter(Boolean).join('|');
    var a = {
      _ddc_ga_cid: gaCid(), _ddc_ga_sid: gaSid(), _ddc_gclid: s.gclid || '', _ddc_gbraid: s.gbraid || '',
      _ddc_wbraid: s.wbraid || '', _ddc_fbp: ck('_fbp'), _ddc_fbc: ck('_fbc') || (s.fbclid ? 'fb.1.' + s.t + '.' + s.fbclid : ''),
      _ddc_utm: utm, _ddc_landing: s.landing || '', _ddc_ref: s.ref || ''
    };
    Object.keys(a).forEach(function (k) { if (!a[k]) delete a[k]; });
    return a;
  }

  // 2) Escribe los atributos en el carrito solo si hay productos y algo cambió
  var busy = false;
  function sync() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.item_count) return;
      var a = attrs(), cur = c.attributes || {}, diff = {};
      Object.keys(a).forEach(function (k) { if (cur[k] !== a[k]) diff[k] = a[k]; });
      if (!Object.keys(diff).length) return;
      return _fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: diff }) });
    }).catch(function () {}).then(function () { busy = false; });
  }

  // Expuesto para que el configurador escriba el origen en el MISMO paso en que guarda la fecha de entrega,
  // antes de redirigir al checkout (si no, la redirección le gana al sync y el pedido llega sin origen).
  window.ddcAttribution = { attrs: attrs };

  // 3) Después de agregar al carrito (fetch) y al cargar cada página
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = _fetch(input, init);
    if (/\/cart\/(add|change)(\.js)?/.test(url)) pr.then(function () { setTimeout(sync, 400); }).catch(function () {});
    return pr;
  };
  if (document.readyState === 'complete') setTimeout(sync, 1500);
  else window.addEventListener('load', function () { setTimeout(sync, 1500); });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) setTimeout(sync, 1500);
  }, true);
})();
